// extracted by mini-css-extract-plugin
module.exports = {"container":"hZ","containerExpand":"h0","headerRow":"h1","headerCol":"h2","image":"h3","title":"h4","date":"h5","dateExpand":"h6"};